import React, { useEffect, useState } from 'react';
import Modal from '../../common/Modal';
import InputWrapper from '../../common/InputWrapper';
import { useFormik } from 'formik';
import Button from '../../common/Button';
import { MOCK_DATA, PACKING_MOCK_DATA, PLACEHOLDER } from './mocks';
import { Wrapper } from './styled';
import PackageItem from './components/PackageItem';
import { hideModal, showModal } from '../../../actions/modal';
import { useDispatch } from 'react-redux';
import { fetchGetPackingOrder, fetchPutPackingOrder } from '../../../actions/orders';
import * as Yup from 'yup';

const EditPackageModal = ({ data }) => {
  const dispatch = useDispatch();
  const [packingData, setPackingData] = useState(null);

  useEffect(() => {
    setPackingData(data);
  }, [data, dispatch]);

  const onClose = () => {
    dispatch(hideModal());
  };

  const handleChangeInput = (id, value) => {
    setFieldValue(id, value);
  };

  const formik = useFormik({
    initialValues: {
      notPackedItems: packingData?.data.orders[0].notPackedItems,
      packings: packingData?.data.orders[0].packings || [],
      newPackingItem: {
        orders: [
          {
            id: packingData?.data.orders[0].id,
            packings: [
              {
                items: packingData?.data.orders[0].notPackedItems,
                num: packingData?.data.orders[0].packings?.length + 1 || 1, //длина массива готовых упаковок + 1
                measurements: {
                  weight: 1,
                  dimensions: {
                    height: 1,
                    width: 1,
                    depth: 1,
                  },
                },
              },
            ],
          },
        ],
      },
    },
    enableReinitialize: true,

    onSubmit: (values) => {
      dispatch(fetchPutPackingOrder(values.newPackingItem));
      dispatch(fetchGetPackingOrder(data.data.orders[0].id));
    },
  });

  const { values, handleSubmit, setFieldValue } = formik;

  const renderRow = (item, index) => {
    return (
      <section className="row">
        <div className="col-1 item-image">
          <img src={item.img} alt={item.article} width="60" height="60" />
        </div>
        <div className="col-6 item-naming">
          <span className="item-name">{item.name}</span>
          <span className="item-article">Артикул: {item.article}</span>
          <span className="item-subname text-muted">{item.variantId}</span>
        </div>
        <div className="col-2">
          <span className="item-quantity__number">{values.notPackedItems[index].quantity} шт.</span>
        </div>
        <div className="col-2">
          <InputWrapper
            label="Количество в упаковке"
            id="quantity"
            type="number"
            value={values.newPackingItem?.orders[0].packings[0].items[index].quantity || 0}
            onChange={(e) =>
              handleChangeInput(
                `newPackingItem.orders[0].packings[0].items.${index}.quantity`,
                e.target.value,
              )
            }
          />
        </div>
      </section>
    );
  };

  return (
    <Wrapper>
      <Modal onClose={() => onClose()} title="Комплектация" className="w-90" hideFooter={true}>
        <form autoComplete="false" onSubmit={(e) => handleSubmit(e)}>
          <div className="main-header-block">
            <h4 className="header-title">Номенклатура</h4>
          </div>
          <div className="row">
            <div className="col-12">
              {values.notPackedItems &&
                values.notPackedItems.map((item, index) => renderRow(item, index))}
            </div>
          </div>
          <div className="row parameters">
            <div className="col-3">
              <InputWrapper
                label="Ширина, см"
                name="width"
                type="number"
                value={values.newPackingItem.orders[0].packings[0].measurements?.dimensions?.width}
                onChange={(e) =>
                  handleChangeInput(
                    `newPackingItem.orders[0].packings[0].measurements.dimensions.width`,
                    e.target.value,
                  )
                }
              />
            </div>
            <div className="col-3">
              <InputWrapper
                label="Высота, см"
                name="height"
                type="number"
                value={values.newPackingItem.orders[0].packings[0].measurements?.dimensions?.height}
                onChange={(e) =>
                  handleChangeInput(
                    `newPackingItem.orders[0].packings[0].measurements.dimensions.height`,
                    e.target.value,
                  )
                }
              />
            </div>
            <div className="col-3">
              <InputWrapper
                label="Глубина, см"
                name="depth"
                type="number"
                value={values.newPackingItem.orders[0].packings[0].measurements?.dimensions?.depth}
                onChange={(e) =>
                  handleChangeInput(
                    `newPackingItem.orders[0].packings[0].measurements.dimensions.depth`,
                    e.target.value,
                  )
                }
              />
            </div>
            <div className="col-3">
              <InputWrapper
                label="Вес, кг"
                name="weight"
                type="number"
                value={values.newPackingItem.orders[0].packings[0].measurements?.weight}
                onChange={(e) =>
                  handleChangeInput(
                    `newPackingItem.orders[0].packings[0].measurements.weight`,
                    e.target.value,
                  )
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-3 offset-9">
              <Button className="align-right" text="Закрыть место" onClick={handleSubmit} />
            </div>
          </div>
        </form>
        <div className="packings-wrapper card-content">
          {values.packings &&
            values.packings.map((item, index) => (
              <PackageItem
                measurements={item.measurements}
                items={item.items}
                barcode={item.barcode}
                num={item.num}
                index={index}
                id={data.data.orders[0].id}
              />
            ))}
        </div>
      </Modal>
    </Wrapper>
  );
};

export default EditPackageModal;
